// import { Grid, Typography } from "@mui/material";

// const AllowedDomains = [
//   "broadacreschartwell.webbieshop.com",
//   "broadacressyringa.webbieshop.com",
//   'd6auth.vercel.app',
//   'mclardies.webbieshop.com',
//   "localhost",
// ];

// export default function AllowedDomainss() {
//   const currentDomain = window.location.hostname;
//   console.log("currentDomain", currentDomain);

//   if (!AllowedDomains.includes(currentDomain)) {
//     return null; // Do not show for other domains
//   }

//   return (
//     <Grid
//       container
//       spacing={0}
//       sx={{
//         mt: 2,
//         p: { xs: 1.5, sm: 2 },
//         border: "1px solid",
//         borderColor: "grey.300",
//         borderRadius: 2,
//         backgroundColor: "grey.50",
//       }}
//     >
//       <Grid item xs={12}>
//         <Typography
//           variant="body2"
//           sx={{
//             fontWeight: 600,
//             fontSize: { xs: "13px", sm: "14px", md: "15px" },
//           }}
//         >
//           When placing an order for your children, please ensure that you
//           complete the following details clearly:
//         </Typography>
//       </Grid>

//       {[
//         "Your child’s full name",
//         "Your child’s class",
//         "The delivery time (First Break, Second Break, or Afterschool)",
//       ].map((text, index) => (
//         <Grid item xs={12} key={index}>
//           <Typography
//             variant="body2"
//             sx={{ fontSize: { xs: "12px", sm: "13px", md: "14px" } }}
//           >
//             • {text}
//           </Typography>
//         </Grid>
//       ))}

//       <Grid item xs={12}>
//         <Typography
//           variant="body2"
//           sx={{
//             fontSize: { xs: "12px", sm: "13px", md: "14px" },
//             color: "text.secondary",
//           }}
//         >
//           This information is important to make sure that your child’s order is
//           delivered correctly and on time.
//         </Typography>
//       </Grid>
//     </Grid>
//   );
// }

import { Grid, Typography } from "@mui/material";

const domainContent = {
  "broadacreschartwell.webbieshop.com": {
    title: "When placing an order for your children, please ensure that you complete the following details clearly:",
    points: [
      "Your child’s full name",
      "Your child’s class",
      "The delivery time (First Break, Second Break, or Afterschool)",
    ],
    note: "This information is important to make sure that your child’s order is delivered correctly and on time.",
  },
  "broadacressyringa.webbieshop.com": {
    title: "When placing an order for your children, please ensure that you complete the following details clearly:",
    points: [
      "Your child’s full name",
      "Your child’s class",
      "The delivery time (First Break, Second Break, or Afterschool)",
    ],
    note: "This information is important to make sure that your child’s order is delivered correctly and on time.",
  },
  "mclardies.webbieshop.com": {
    title: "Please add these in your Order Note",
    points: [
      "Your child’s full name.",
      "Your child’s class.",
      "Any special requirements (Allergies).",
    ],
    note: "This information is important to make sure that your child’s order is delivered correctly and on time.",
  },
  "d6auth.vercel.app": {
    title: "Demo Instructions",
    points: ["Point A", "Point B", "Point C"],
    note: "This is a demo environment for testing purposes.",
  },
  "localhost": {
    title: "Please add these in your Order Note",
    points: [
      "Your child’s full name.",
      "Your child’s class.",
      "Any special requirements (Allergies).",
    ],
    note: "This information is important to make sure that your child’s order is delivered correctly and on time.",
  },
};

export default function AllowedDomainss() {
  const currentDomain = window.location.hostname;
  const content = domainContent[currentDomain];

  if (!content) return null; // Show nothing for other domains

  return (
    <Grid
      container
      spacing={0}
      sx={{
        mt: 2,
        p: { xs: 1.5, sm: 2 },
        border: "1px solid",
        borderColor: "grey.300",
        borderRadius: 2,
        backgroundColor: "grey.50",
      }}
    >
      <Grid item xs={12}>
        <Typography
          variant="body2"
          sx={{
            fontWeight: 600,
            fontSize: { xs: "13px", sm: "14px", md: "15px" },
          }}
        >
          {content.title}
        </Typography>
      </Grid>

      {content.points.map((text, index) => (
        <Grid item xs={12} key={index}>
          <Typography
            variant="body2"
            sx={{ fontSize: { xs: "12px", sm: "13px", md: "14px" } }}
          >
            • {text}
          </Typography>
        </Grid>
      ))}

      <Grid item xs={12}>
        <Typography
          variant="body2"
          sx={{
            fontSize: { xs: "12px", sm: "13px", md: "14px" },
            color: "text.secondary",
          }}
        >
          {content.note}
        </Typography>
      </Grid>
    </Grid>
  );
}
